export const TimelineSymbol = Symbol('timeline');
